import { makeStyles } from "@material-ui/core";

export const RutaVueloStyle = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
  },
  lineContainer: {
    position: "relative",
    height: 2,
    backgroundColor: theme.palette.secondary.main,
    margin: "0 8px",
    display: "flex",
    alignItems: "center",
  },
  exploreIcon: {
    marginRight: "0.5rem",
  },
  dot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.light,
    position: "absolute",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
}));